var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 11.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.202 2a3 3 0 0 1 2.121.879l3.798 3.798A3 3 0 0 1 22 8.797v6.405l-.015.296a3.001 3.001 0 0 1-.864 1.825l-3.798 3.798-.22.2a3 3 0 0 1-1.9.679H8.797a3 3 0 0 1-2.121-.879l-3.798-3.798a3 3 0 0 1-.864-1.825L2 15.202V8.798a3 3 0 0 1 .68-1.902l.199-.22L6.677 2.88A3 3 0 0 1 8.797 2h6.405ZM8.798 3.5a1.5 1.5 0 0 0-1.06.44l-3.8 3.796a1.5 1.5 0 0 0-.439 1.06v6.405c0 .398.158.78.44 1.06l3.797 3.799a1.5 1.5 0 0 0 1.06.439h6.405a1.5 1.5 0 0 0 1.06-.44l3.799-3.797a1.5 1.5 0 0 0 .439-1.06V8.797a1.5 1.5 0 0 0-.44-1.06l-3.797-3.799a1.5 1.5 0 0 0-1.06-.439H8.797Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.8bd164d2aba9fb9860f9058c22928adb.svg";
export { ForwardRef as ReactComponent };